import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ConfirmModal } from '../../ui';
import Toast from '../../Toast';
import cronJobsService from '../../../services/cronJobsService';
import { useContextHook } from 'use-context-hook';
import { AuthContext } from '../../../Context/authContext';
import { queryKeys } from '../../../hooks/queryKeys';

/**
 * Delete Task confirm modal.
 * API unchanged: cronJobsService.deleteJob → DELETE /cronjob/delete
 */
const DeleteJobModal = ({ onClose, data, setEditingJob }) => {
  const queryClient = useQueryClient();

  const { refetch } = useContextHook(AuthContext, v => ({
    refetch: v.refetch,
  }));

  const handleSubmit = useMutation({
    mutationFn: async () => {
      return await cronJobsService?.deleteJob(data?.id || data?.job_id);
    },
    retry: 1,
    onSuccess: response => {
      Toast({
        type: 'success',
        message: response.detail,
      });
      refetch();
      setEditingJob?.(null);
      onClose();
      queryClient.invalidateQueries({ queryKey: queryKeys.cronJobs.all });
      queryClient.invalidateQueries({ queryKey: ['sessions'] });
    },
    onError: err => {
      Toast({
        type: 'error',
        message: err.detail,
      });
    },
  });

  return (
    <ConfirmModal
      title="Delete Task"
      message={
        <p>
          Are you sure you want to delete <span className="text-ink font-medium">{data?.name || 'this task'}</span>?
          There is no way to recover it.
        </p>
      }
      confirmLabel="Delete"
      busyLabel="Deleting..."
      loading={handleSubmit.isPending}
      onConfirm={() => handleSubmit.mutate()}
      onClose={onClose}
    />
  );
};

export default DeleteJobModal;
